import type { ComponentPropsWithRef } from "react";
import { Icon, type IconType } from "@/react/components/shared/Icon";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

export interface MenuBarItemProps extends ComponentPropsWithRef<"button"> {
  icon: IconType;
  isActive?: boolean;
}

export const MenuBarItem = ({ icon, isActive, ...props }: MenuBarItemProps) => (
  <button
    type="button"
    className={classNames(
      "hover:bg-secondary flex size-6 items-center justify-center rounded border border-transparent",
      {
        "bg-tertiary border-primary": isActive,
      },
    )}
    onMouseDown={e => e.preventDefault()}
    {...props}
  >
    <Icon
      type={icon}
      size={14}
      className={classNames("text-dark", {
        "text-brand": isActive,
      })}
    />
  </button>
);
